export default __webpack_public_path__ + "static/media/Group -12-Yono.508fbdc1.png";